import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPaddleIncompleteCheckoutGet = {
    path: "/paddle/incomplete-checkout",
    method: ERouteHttpVerb.GET
};
export { routeLocationPaddleIncompleteCheckoutGet };
